/** 海外媒体平台（B-1 契约：4=海讯社 / 5=媒介易 / 6=Leadmore）
 * 用户侧按业务口径展示，不暴露平台商（代理商）名称
 */
const PLATFORM_LABELS: Record<number, string> = {
  4: '套餐发布', // 海讯社
  5: '单平台发布', // 媒介易
  6: 'Reddit', // Leadmore
}

/**
 * 取平台展示名：优先按平台编号取业务口径名，取不到时回退接口返回的平台名
 * @param platform 平台编号（4 海讯社 / 5 媒介易 / 6 Leadmore）
 * @param platformName 接口返回的平台名，兜底用
 */
export function getOverseasPlatformLabel(platform?: number | string, platformName?: string) {
  return PLATFORM_LABELS[Number(platform)] || platformName || ''
}

/** Reddit 展示名：发Reddit 为表单发布、无服务项，「提交媒体」等列按平台业务口径展示 */
export const REDDIT_PLATFORM_LABEL = PLATFORM_LABELS[6]
